import React, { useState } from 'react'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import { GraphQLFormProvider, FormField } from '@mymeerkat/react-form-helper'
import { isInteger } from '../../lib/validations'
import { renderInput, BuildLayout, renderDisplay } from '../generic';
import { FUNERAL_PAYMENT_TYPES, OMAS_FUNERAL_PAYMENT_TYPES } from '../../variables/paymentTypes'
import { funeralInformation } from './FuneralInfo'
import Numeral from 'numeral'
import 'numeral/locales/en-za.js'

// switch between locales
Numeral.locale('en-za')

const FUNERAL_PRICING_VERSIONS = ['BSSP_LOW_RISK_20240801', 'BSSP_STANDARD_RISK_20240801', 'BSSP_HIGH_RISK_20240801', 'BSSP_LOW_RISK_20250701', 'BSSP_STANDARD_RISK_20250701', 'BSSP_HIGH_RISK_20250701', 'BSSP_HIGH_RISK_PLUS_20_20250701', 'BSSP_HIGH_RISK_PLUS_30_20250701', 'BSSP_HIGH_RISK_PLUS_40_20250701']

const config = {
  name: 'funeral',
  fields: {
    coverAmount: {
      type: 'select',
      label: 'Coverage Amount',
      options: [],
      disabled: false,
      validate: (value) => {
        if (!value) {
          return 'Amount is required'
        }
      }
    },
    'paymentMethod': {
      type: 'select',
      label: 'Payment Method',
      options: FUNERAL_PAYMENT_TYPES.map(e => ({ label: e, value: e })).sort((a, b) => (a <= b ? -1 : 1))
    },
    'paymentDueDay': {
      type: 'text',
      label: 'Payment Due Day ',
      validate: (value) => {
        if (!value) {
          return 'Day of the month is required'
        }
        else if (value && isInteger(value)) {
          return 'Must be a day of the month'
        } else if (value && (value > 31 || value < 1)) {
          return 'Must be a day of the month'
        }
      }
    },
      'pricingVersion': {
      type: 'select',
      label: 'Pricing Version',
      options: FUNERAL_PRICING_VERSIONS.map(v => ({ label: v, value: v })).sort((a, b) => (a <= b ? -1 : 1)),
      validate: (value) => {
        if (!value) {
          return 'Pricing Version is required'
        }
      }
    },
    'premiumCreditorEnabled': {
      type: 'switch',
      label: "Premium Creditor Enabled"
    }
  },
  query: gql`
    query FuneralData($id: String!) {
      funeral(id: $id) {
        id
        paymentDueDay
        paymentMethod
        coverAmount
        premiumCreditorEnabled
        pricingVersion
        accountingIdentifier
      }
    }`,
  updateMutation: gql`
    mutation UpdateFuneral($input: UpdateFuneralInput!, $id: String!) {
      updateFuneral(id: $id, input: $input) {
        id
        paymentDueDay
        paymentMethod
        coverAmount
        premiumCreditorEnabled
        pricingVersion
      }
  }`,
  addMutation: gql`
  mutation CreateFuneral($input: CreateFuneralInput!) {
    createFuneral(input: $input) {
      id
      paymentDueDay
      paymentMethod
      coverAmount
      premiumCreditorEnabled
    }
  }`
}

const FormLayout = (props) => {
  console.log('edit funeral props', props)
  let { cancel, history, data, formName } = props;
  let { funeral } = data || {};
  let { coverAmount } = funeral || 0;

  const coverage = []
  let cover = 10000;
  while (cover <= coverAmount) {
    coverage.push(cover);
    cover += 10000;
  }
  config.fields['coverAmount'].options = coverage.map(a => ({
    value: a, label: Numeral(a).format('$ ##,###0.')
  }))

  const paymentTypeOptions = (funeral && funeral.accountingIdentifier === 'OMAS') ? OMAS_FUNERAL_PAYMENT_TYPES : FUNERAL_PAYMENT_TYPES
  config.fields['paymentMethod'].options = paymentTypeOptions.map(e => ({ label: e, value: e })).sort((a, b) => (a <= b ? -1 : 1))

  return (<BuildLayout formName={formName }  fieldNames={Object.keys(config.fields)} fieldConfig={config.fields} direction='column' spacing={2} align='center' justify='center' cancel={cancel} push={() => history.push('/bankaccounts')} />);
}

let EditFuneral = (props) => {

  const { cancel, id, history, coverageChanges } = props

  if (!coverageChanges) {
    config.fields['coverAmount'].disabled = true
  }

  return (
    <div>
      <GraphQLFormProvider
        mode="edit"
        id={id}
        {...config}
        afterSubmit={({ data }) => { cancel() }}
        renderDisplay={renderDisplay}
        renderInput={renderInput}
        InputFormLayout={(props) => <FormLayout {...props} formName={config.name} cancel={cancel} history={history} />}
        DisplayFormLayout={FormLayout}
        initialValuesFromData={data => data.funeral}
        refetchQueries={[{ query: funeralInformation, variables: { id } }]}
        mapInputVariables={props => {
          console.log('map input variables', props)
          let { firstNames, surname, accountingIdentifier, ...input } = props
          if (firstNames) {
            input.firstNames = nameCase(firstNames)
          }
          if (surname) {
            input.surname = nameCase(surname)
          }
          return ({ input })
        }}
      // defining the input to use the input needed in the update mutation.
      />
    </div>
  )
}

EditFuneral = withApollo(EditFuneral);
export default EditFuneral